module.exports = __webpack_public_path__ + "static/media/Homepage_Expertise-Solutions.67a89da7.jpg";